module.exports = __webpack_public_path__ + "img/hc.7af9e124.jpg";